import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectPricesByTicker } from 'store/selectors/prices'
import { cacheImages } from 'utils/iconCache'

/**
 * Hook to preload common currency icons when prices are available
 * This improves perceived performance by caching icons before they're needed
 */
const useIconPreloader = () => {
  const pricesByTicker = useSelector(selectPricesByTicker)

  useEffect(() => {
    if (!pricesByTicker || Object.keys(pricesByTicker).length === 0) {
      return
    }

    // Common currencies that are frequently displayed
    const COMMON_TICKERS = [
      'BTC',
      'ETH',
      'USD',
      'USDT',
      'USDC',
      'BNB',
      'SOL',
      'ADA',
      'XRP',
      'DOT',
      'DOGE',
      'MATIC',
      'AVAX',
      'LINK',
      'UNI',
      'ATOM',
      'LTC',
      'BCH',
      'XLM',
      'ALGO',
    ]

    // Extract icon URLs for common currencies
    const iconUrls = COMMON_TICKERS.map((ticker) => pricesByTicker[ticker]?.image).filter(Boolean)

    if (iconUrls.length > 0) {
      // Preload common icons in background
      cacheImages(iconUrls).catch(() => {
        // Silently fail - preloading is best effort
      })
    }
  }, [pricesByTicker])
}

export default useIconPreloader
